export { default as getAlgolia } from './lib/algolia-factory';
export * from './utils';
